import { atom } from "recoil";
import { Tool } from "../types";

export const toolState = atom<Tool>({
  key: "toolState",
  default: {toolName: '', toolPrettyLabel: ''},
});